// Pricing Table blocks

// Add scroll wrapper to pricing tables
document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('figure.wp-block-table.is-style-pricing-features table').forEach(table => {
		// Skip if already wrapped
		if (table.parentElement.classList.contains('scroll-wrapper')) return;

		const wrapper = document.createElement('div');
		wrapper.classList.add('scroll-wrapper', 'scroll-sync-table');

		table.parentElement.insertBefore(wrapper, table);
		wrapper.appendChild(table);
	});
});

document.addEventListener('DOMContentLoaded', function () {
	const syncTables = document.querySelectorAll('.scroll-sync-table');

	syncTables.forEach(sourceEl => {
		sourceEl.addEventListener('scroll', () => {
			const scrollLeft = sourceEl.scrollLeft;
			syncTables.forEach(targetEl => {
				if (targetEl !== sourceEl) {
					targetEl.scrollLeft = scrollLeft;
				}
			});
		});
	});
});


document.addEventListener('DOMContentLoaded', function () {
	const containers = document.querySelectorAll('td, .info-icon-hover');

	containers.forEach(container => {
		const icon = container.querySelector('.wp-rich-text-font-awesome-icon');

		if (icon && container.childNodes.length > 1) {
			// Find the next sibling text node
			const nextNode = icon.nextSibling;
			if (nextNode && nextNode.nodeType === Node.TEXT_NODE) {
				const text = nextNode.textContent.trim();
				if (text.length) {
					const infoSpan = document.createElement('span');
					infoSpan.className = 'info-hover-text';
					infoSpan.textContent = text;

					nextNode.textContent = ''; // Clear the raw text
					container.appendChild(infoSpan);
					container.classList.add('has-info-hover');
				}
			}
		}
	});
});

